import burntoearn from '../assets/png/projects/burntoearn.png'
import casino from '../assets/png/projects/casino.png'
import dfsscan from '../assets/png/projects/dfsscan.png'
import difines from '../assets/png/projects/difines.png'
import echosystem from '../assets/png/projects/echosystem.png'
import metaface from '../assets/png/projects/metaface.png'
import micro_bitcoin from '../assets/png/projects/micro_bitcoin.png'
import plinko from '../assets/png/projects/plinko.png'
import pump from '../assets/png/projects/pump.png'
import reoppongi_ai from '../assets/png/projects/reoppongi_ai.png'
import lotto from '../assets/png/projects/lotto.png'
import speaking_girl from '../assets/png/projects/speaking_girl.png'
import spin from '../assets/png/projects/spin.png'
import stakes from '../assets/png/projects/stakes.png'
import token_bridge from '../assets/png/projects/token_bridge.png'
import mining from '../assets/png/projects/mining.png'
import betting from '../assets/png/projects/betting.png'


export const projectsData = [
    {
        id: 1,
        projectName: 'Coin365 - Best Online Casino, Slots & Sports Betting',
        projectDesc: 'Join Coin365 for the ultimate online gambling experience! Play casino games, slots, sports betting, and live casino. Best odds, secure payments, and 24/7 support.',
        tags: ['Typescript', 'Ether.js', 'Solidity'],
        image: betting
    },
    {
        id: 2,
        projectName: 'Micro Bitcoin Spin',
        projectDesc: 'マイクロビットコインの魅力. 豊富なコンテンツが続々と誕生し、「使えるビットコイン」として. 少額から使えるビットコインのマイクロペイメントとして. ビットコインの価格と常に連動している. 100万分の1の価格だから買いやすく便利.',
        tags: ['Typescript', 'Ether.js', 'Solidity'],
        image: spin
    },
    {
        id: 3,
        projectName: 'Sato Pump',
        projectDesc: 'The First Nulti-Functional Meme Coin DEX Platform & DEX Hub on the EVM Chain. Control the token environment freely. Enjoy your referral feature.',
        tags: ['React', 'SCSS', 'Web3.js', 'Solidity',],
        image: pump
    },
    {
        id: 4,
        projectName: 'DifinesNFT',
        projectDesc: 'Support binance and ethereum chains for now. Create NFT easily within 10 seconds per click. Plan to add more evm chains such like polygon, avax and etc.',
        tags: ['React', 'SCSS', 'Web3.js', 'Solidity',],
        image: difines
    },
    {
        id: 5,
        projectName: 'DFS Scan',
        projectDesc: 'DFS Scan is a tool that allows you to scan the DFS network for transactions and blocks. It provides a user-friendly web interface to explore and analyze blockchain data, including transaction history and smart contract interactions.',
        tags: ['Next', 'Tailwind', 'Firebase', 'Difines', 'Web2'],
        image: dfsscan
    },
    {
        id: 6,
        projectName: 'MetaFace',
        projectDesc: 'MetaFace is a secure wallet on the DFSChain platform, enabling universal access to the Web2.5 ecosystem. It is a web-based wallet that allows you to send and receive tokens.',
        tags: ['Next', 'Tailwind', 'Firebase', 'Difines', 'Web2'],
        image: metaface
    },
    {
        id: 7,
        projectName: 'Burn to Earn',
        projectDesc: 'Burn the token with low price and get the high price of token and make the profit. Burn the locked token and get the high price of token. Supports over 10+ meme coins.',
        tags: ['React', 'React', 'Burn to Earn', 'Solidity', 'hardhat'],
        image: burntoearn
    },
    {
        id: 8,
        projectName: 'Micro Bitcoin',
        projectDesc: 'Micro Bitcoin is a user-friendly cryptocurrency, represending one-millionth of of a Bitcoin. It offers the flexibility of a BEP-20 token. 1,000,000 uBTC = 1 BTC.',
        tags: ['Meme', 'React', 'Burn to Earn', 'Solidity', 'hardhat'],
        image: micro_bitcoin
    },
    {
        id: 9,
        projectName: 'XMR-Casinor Platform',
        projectDesc: 'Step into the thrill of winning with our sleek and secure online casino! Enjoy a wide selection of games, from classic slots to exciting table games, all designed to bring the Vegas experience right to your screen.',
        tags: ['Ethers', 'React', 'Wallet Connect', 'Solidity', 'hardhat'],
        image: casino
    },

    {
        id: 10,
        projectName: 'Reoppongi Ai',
        projectDesc: 'AI website development. Wordpress theme. Elementor Pro',
        tags: ['Wordpress', 'AI', 'HTML', 'CSS', 'Javascript'],
        image: reoppongi_ai
    },

    {
        id: 11,
        projectName: 'PLINKO | Lotto Game',
        projectDesc: 'Step into the thrill of winning with our sleek and secure online casino! Enjoy a wide selection of games, from classic slots to exciting table games, all designed to bring the Vegas experience right to your screen.',
        tags: ['DApp', 'Lotto', 'Blockchain', 'Solidity', 'Web3'],
        image: plinko
    },

    {
        id: 12,
        projectName: 'Speaking Girl AI',
        projectDesc: 'Use ChatGPT, Use Microsoft Azure for TTS function',
        tags: ['AI', 'React', 'ChatGPT', 'Microsoft'],
        image: speaking_girl
    },

    {
        id: 13,
        projectName: 'Shibuya Echosystem',
        projectDesc: 'Has special mechanism called Golden Tree that can make the token price never go down and rise day by day. Designed that SMTC token that is the main token of Golden Tree that has the special mechanism will be over 100k BUSD finally.',
        tags: ['Ethers', 'React', 'Wallet Connect', 'Solidity', 'hardhat'],
        image: echosystem
    },

    {
        id: 14,
        projectName: 'Staking platform',
        projectDesc: 'Has 5 level referral system working on CEX. Staking with multiple tokens working on DEX. Re-staking, withdrawing and add-staking are possible. Strong reward system based on star earning for each actions.',
        tags: ['Web3', 'React', 'Binance Smart Chain', 'Solidity'],
        image: stakes
    },

    {
        id: 15,
        projectName: 'Token Bridge',
        projectDesc: 'Support the multichain token transfer. Created the bridge backend and bridge smart contract on ethereum and binance. Built with web3.js, react.js, node.js and solidity.',
        tags: ['Ethers', 'React', 'Bridge', 'Solidity', 'hardhat'],
        image: token_bridge
    },

    {
        id: 16,
        projectName: 'Mining P2E Game',
        projectDesc: 'Play to Earn web3 mining game. Integrate NFT assets with the game. Buy the NFTs to earn much more token.',
        tags: ['Vue', 'Web3', 'Wallet Connect', 'Solidity', 'Binance Smart Chain'],
        image: mining
    },

    {
        id: 17,
        projectName: 'Lucky Wheel Lotto Dapp',
        projectDesc: 'Lotto game development, Blockchain development, Lotto token integration',
        tags: ['Dapp', 'Lotto', 'Blockchain', 'Solidity', 'Web3'],
        image: lotto
    },
]